<template>
  <div class="battery-add">
    <div class="row">
      <div class="label">{{ deviceType == 'displayScreen' ? 'UUID' : '设备通讯板编号' }}</div>
      <div class="row-right">
        <el-input class="fixed-width-200" type="text" v-model="physicalNo"
                  :placeholder="deviceType == 'displayScreen' ? '请输入UUID' : '请输入设备通讯板编号'"></el-input>
      </div>
    </div>
    <div class="row" v-if="deviceType == 'displayScreen'">
      <div class="label">规格</div>
      <div class="row-right">
        <el-select class="fixed-width-200" size="mini" v-model="specifications">
          <el-option v-for="(item) in specificationsList" :key="item.id" :label="item.name"
                     :value="item.id"></el-option>
        </el-select>
      </div>
    </div>
    <div class="row">
      <div class="normal-btn" @click="cancel">取消</div>
      <div class="blue-btn" @click="confirm">确认</div>
    </div>
  </div>
</template>
<script>
import Utils from "../../utils/utils";

export default {
  name: "chargeCabinetMgmtAddView",
  props: ["deviceType"],
  data() {
    return {
      addFlag: true,
      physicalNo: "",
      specificationsList: [
        {
          id: "100",
          name: "竖屏 16.5寸"
        },
        {
          id: "101",
          name: "横屏 10.1寸"
        }
      ],
      specifications: '100'
    };
  },
  mounted() {
  },
  methods: {
    confirm() {
      if (this.deviceType != "displayScreen") {
        this.addOrEditDevice();
      } else {
        this.addDisplayScreen();
      }
    },

    cancel() {
      this.$emit("cancel");
    },

    addOrEditDevice() {
      let self = this;
      let params = {
        physicalNo: this.physicalNo,
        deviceType: this.deviceType
      };
      if (!this.addFlag) {
        console.log(111);
        return;
      }
      this.addFlag = false;
      this.$http
        .post(
          "/managementPlatform/electricity/addPrimaryDeviceInfo",
          this.$qs.stringify(params)
        )
        .then(function (response) {
          let res = response.data;
          if (!res || !res.result) {
            self.$message({
              type: "error",
              message: res.message,
              center: true
            });
            return;
          }
          self.$message({
            type: "success",
            message: "添加成功!",
            center: true
          });
          self.$emit("addSuccess");

        })
        .catch(function (response) {
          console.log(response);
        });
      setTimeout(() => {
        this.addFlag = true;
      }, 1000);
    },

    addDisplayScreen() {
      let self = this;
      let params = {
        uuid: this.physicalNo,
        specifications: this.specifications
      };
      this.$http
        .post(
          "/managementPlatform/electricity/addAndEditDisplayScreen",
          this.$qs.stringify(params)
        )
        .then(function (response) {
          let res = response.data;
          if (!res || !res.result) {
            self.$message({
              type: "error",
              message: res.message,
              center: true
            });
            return;
          }
          self.$message({
            type: "success",
            message: "添加成功!",
            center: true
          });
          self.$emit("addSuccess");
        })
        .catch(function (response) {
          console.log(response);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.row {
  margin: 20px 0 0 20px;
  font-size: 14px;

  .fixed-width {
    width: 240px;
  }

  .row-right {
    display: inline-block;
    line-height: 30px;

    .top {
      vertical-align: top;
      color: #999999;
    }
  }

  .label {
    display: inline-block;
    vertical-align: top;
    text-align: left;
    min-width: 100px;
    margin-right: 14px;
    line-height: 25px;
  }

  .blue-btn {
    margin-right: 10px;
  }

  .table-custom {
    width: 920px;
  }

  .fixed-width-200 {
    width: 200px;
    vertical-align: top;
  }

  .fixed-width-350 {
    width: 350px;
    vertical-align: top;
  }

  .fixed-width-450 {
    width: 450px;
    vertical-align: top;
  }

  .btn {
    cursor: pointer;
  }

  .icon {
    color: #67aa42;
    font-size: 20px;
  }
}

.amap-demo {
  height: 300px;
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/deviceMgmt/chargeCabinetMgmtAddView.vue